module.exports = __webpack_public_path__ + "img/bell-icon.294b6467.svg";